export const countries = [
  { label: "Bénin", value: "BJ" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Cameroun", value: "CM" },
  { label: "Congo-Brazzaville", value: "CG" },
  { label: "République Démocratique du Congo", value: "CD" },
  { label: "Gabon", value: "GA" },
  { label: "Ghana", value: "GH" },
  { label: "Côte d'Ivoire", value: "CI" },
  { label: "Kenya", value: "KE" },
  { label: "Lesotho", value: "LS" },
  { label: "Malawi", value: "MW" },
  { label: "Mozambique", value: "MZ" },
  { label: "Nigeria", value: "NG" },
  { label: "Rwanda", value: "RW" },
  { label: "Sénégal", value: "SN" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Tanzanie", value: "TZ" },
  { label: "Ouganda", value: "UG" },
  { label: "Zambie", value: "ZM" },
  { label: "Éthiopie", value: "ET" },
  { label: "Mali", value: "ML" },
];
